import Check from '@mui/icons-material/Check';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import MenuItem from '@mui/material/MenuItem';
import Typography from '@mui/material/Typography';
import PropTypes from 'prop-types';
import React from 'react';
import SelectButton from '../buttons/SelectButton';
import {
  FORM_SELECT_BUTTON_CLASS_NAME,
  FORM_SELECT_MENU_CLASS_NAME,
} from '../../theme/constants/select';

const DocumentTypeSelect = ({
  value,
  onChange,
  options,
  label,
  isAlreadyUploaded,
  allowAlreadyUploaded,
  sx,
  ...props
}) => {
  const renderValue = (selected) => {
    const option = options.find((document) => document.code === selected);
    return (
      <Typography
        component="span"
        variant="small_2"
        color="gray.A700"
        fontWeight={500}
        noWrap
      >
        {option?.name ?? label}
      </Typography>
    );
  };

  return (
    <SelectButton
      value={value}
      onChange={(event) => onChange(event.target.value)}
      displayEmpty
      className={FORM_SELECT_BUTTON_CLASS_NAME}
      MenuProps={{ PaperProps: { className: FORM_SELECT_MENU_CLASS_NAME } }}
      renderValue={renderValue}
      sx={{
        width: 250,
        maxWidth: 250,
        '& .MuiSelect-select': {
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
        },
        ...sx,
      }}
      {...props}
    >
      {options.map((document) => {
        const alreadyUploaded = isAlreadyUploaded(document);
        return (
          <MenuItem
            key={document.id}
            value={document.code}
            disabled={alreadyUploaded && !allowAlreadyUploaded}
          >
            <ListItemText>
              {document.name}
            </ListItemText>
            {alreadyUploaded && (
              <ListItemIcon size="small">
                <Check color="success" />
              </ListItemIcon>
            )}
          </MenuItem>
        );
      })}
    </SelectButton>
  );
};

DocumentTypeSelect.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  options: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    code: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
  })),
  label: PropTypes.string,
  isAlreadyUploaded: PropTypes.func,
  allowAlreadyUploaded: PropTypes.bool,
  sx: PropTypes.shape({}),
};

DocumentTypeSelect.defaultProps = {
  value: '',
  options: [],
  label: 'Elige tipo de documento',
  isAlreadyUploaded: () => false,
  allowAlreadyUploaded: false,
  sx: {},
};

export default DocumentTypeSelect;
